import { render, staticRenderFns } from "./TwoFactorAuthenticationInput.vue?vue&type=template&id=1d1e0b2c&scoped=true"
import script from "./TwoFactorAuthenticationInput.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationInput.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthenticationInput.vue?vue&type=style&index=0&id=1d1e0b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e0b2c",
  null
  
)

export default component.exports